import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
	//#region Auth
	{
		path: 'logout',
		canActivate: [AuthGuard],
	},
	{
		path: 'login',
		loadChildren: () => import('./pages/auth/login/login.module').then((m) => m.LoginPageModule),
	},
	{
		path: 'signup',
		loadChildren: () => import('./pages/auth/signup/signup.module').then(m => m.SignupPageModule),
	},
	{
		path: 'confirm-email',
		loadChildren: () => import('./pages/auth/confirm-email/confirm-email.module').then(m => m.ConfirmEmailPageModule)
	},
	{
		path: 'recover-password',
		loadChildren: () => import('./pages/auth/recover-password/recover-password.module').then(m => m.RecoverPasswordPageModule)
	},
	{
		path: 'reset-password',
		loadChildren: () => import('./pages/auth/reset-password/reset-password.module').then(m => m.ResetPasswordPageModule)
	},
	//#endregion Auth

	{
		path: 'welcome',
		loadChildren: () => import('./pages/onboarding/onboarding.module').then((m) => m.OnboardingPageModule),
		canActivate: [AuthGuard],
	},
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'trip',
	},
	{
		path: '',
		loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
		canActivate: [AuthGuard],
		pathMatch: 'prefix',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
	exports: [RouterModule],
})
export class AppRoutingModule { }
